export const GOOGLE_FILEPICKER = {
    GENERAL : {
        CLIENT_ID: '462509078298-buajqdg1p43g0c5q0nfs2jhasc6m4051',
        DEVELOPER_KEY: 'AIzaSyDb4XNwRSotAlAr1VDvt3nDq3CBn_dV7v8',
        SCOPE: ['https://www.googleapis.com/auth/drive.readonly', 'https://www.googleapis.com/auth/drive', 'https://www.googleapis.com/auth/drive.file', 'https://www.googleapis.com/auth/drive.appdata', 'https://www.googleapis.com/auth/drive.apps.readonly'],
    },
    IMAGE_PICKER : {
        FODLER_ID: '1p3C7shrTXWmtU6UXSxceyO9fQrit8ZJk',
        URL_PREFIX: "https://lh3.google.com/u/0/d/",
        URL_SUFFIX: "=w1600-h789-iv1"
    },
    DOCUMENT_PICKER : {
        FODLER_ID: '1Uk0NtSBYzX-WYdv7ctC_S8fltOWKCmIV',
        URL_PREFIX: "https://docs.google.com/uc?id="
    }
};